<template>
	<th><slot></slot></th>
</template>

<script>
	export default {
		/*mounted() {
			this.$parent.$parent.calc();
		}*/
	}
</script>